import {
  AnyTeamGroupEntityVersion,
  Collections,
  FirestoreEntity,
  isNonEmptyString,
  Mapper,
  TeamGroup,
  TeamGroupEntity,
} from '@uploadcam/common';
import { addDoc, CollectionReference, Firestore, Timestamp } from 'firebase/firestore';
import { getCollectionRef } from '../../../../@harmony/angular';
import invariant from 'tiny-invariant';

export interface TeamGroupData {
  email: string;
  name: string;
}

export function assertTeamGroupData(data: Partial<TeamGroupData>): asserts data is TeamGroupData {
  invariant(isNonEmptyString(data.email), `'email' must be defined`);
  invariant(isNonEmptyString(data.name), `'name' must be defined`);
}

export class CreateTeamGroupInteractor {
  private readonly collection: CollectionReference<AnyTeamGroupEntityVersion>;

  constructor(
    private readonly db: Firestore,
    private readonly mapper: Mapper<FirestoreEntity<AnyTeamGroupEntityVersion>, TeamGroup>,
  ) {
    this.collection = getCollectionRef(this.db, Collections.TeamGroups);
  }

  public async execute(teamId: string, data: TeamGroupData): Promise<TeamGroup> {
    assertTeamGroupData(data);
    invariant(isNonEmptyString(teamId), `'teamId' must be defined`);

    const entity: TeamGroupEntity = {
      _version: 0,
      createdAt: Timestamp.now(),
      email: data.email,
      name: data.name,
      teamId,
      users: [],
    };

    const docRef = await addDoc(this.collection, entity);

    return this.mapper.map(new FirestoreEntity(docRef.id, entity));
  }
}
